import { useEffect, useState } from 'react';

import { envConfig } from '#constants/envConfig';
import { isImageStoreAvailable, knownImageStoreAvailability } from '../utils/imageStore';

/**
 * Есть ли хранилище картинок на этой платформе. В вебе – всегда `false` без единого вызова; в
 * приложении ответ приходит после загрузки плагина, дальше известен сразу.
 */
export const useImageStoreAvailable = (): boolean => {
  const [available, setAvailable] = useState(
    () => envConfig.IS_NATIVE && knownImageStoreAvailability() === true
  );

  useEffect(() => {
    if (!envConfig.IS_NATIVE || available) {
      return;
    }
    let active = true;
    void (async () => {
      const value = await isImageStoreAvailable();
      if (active) {
        setAvailable(value);
      }
    })();
    return () => {
      active = false;
    };
  }, [available]);

  return available;
};
